export interface QuickApp {
  name: string
  slug: string
}

export const quickApps: QuickApp[] = [
  { name: 'Wordpress', slug: 'wordpress' },
  { name: 'N8n', slug: 'n8n' },
  { name: 'Gitea', slug: 'gitea' },
  { name: 'Gitlab', slug: 'gitlab' },
  { name: 'Jira', slug: 'jira' },
  { name: 'Keycloak', slug: 'keycloak' },
  { name: 'Confluence', slug: 'confluence' },
  { name: 'Kibana', slug: 'kibana' },
  { name: 'Metabase', slug: 'metabase' },
  { name: 'Pocketbase', slug: 'pocketbase' },
  { name: 'Vaultwarden', slug: 'vaultwarden' },
  { name: 'Filestash', slug: 'filestash' },
  { name: 'Parseable', slug: 'parseable' },
  { name: 'UptimeKuma', slug: 'uptime-kuma' },
  { name: 'Matomo', slug: 'matomo' },
  { name: 'Navidrome', slug: 'navidrome' },
  { name: 'PgHero', slug: 'pghero' },
  { name: 'OpenWebUI', slug: 'openwebui' },
]
